import { getPreviousMonday, getSelectedDates, convert_date_to_timestamp, get_days, get_weeks, get_months, get_years } from './dates'


export function checkString(data){
  if (typeof data != "undefined") {
    if (typeof data === "string") {
      if (data.length > 0){
        if (data.trim() != ""){
          return true;
  
        }
      }
    }


  }

  return false;
}


export function checkArray(data){

  if (typeof data != "undefined") {
    if (data.length > 0){
      return true;

    }
  }

  return false;
}

export function removeCommonValues(arr1, arr2) {
  const set1 = new Set(arr1);

  for (let i = 0; i < arr2.length; i++) {
    if (set1.has(arr2[i])) {
      arr1.splice(arr1.indexOf(arr2[i]), 1);

      arr2.splice(i, 1);

      i--;
    }
  }
}

export function removeValueFromArray(value, array) {
  const index = array.indexOf(value);
  if (index !== -1) {
    array.splice(index, 1);
  }
  return array;
}


export function createTopFilters(topFilter, language){
  if (Object.keys(topFilter).length != 0 && topFilter.constructor === Object){

    let top_filter = {
      id: 9999999,
      position: 'top',
      type: topFilter.type,
      name: topFilter.populate,
      title: topFilter.populate ,
      value: "all",
      all_text: topFilter.all_text,
      choose_text: topFilter.choose_text,
      // today: topFilter.today,
      or: false,
    }
    if (topFilter.type == "date") {
      const today = new Date();

      let topFilterDate = new Date(today);

      if (topFilter.populate == "auto") {

        let options = get_days(topFilter.today);
        top_filter.options = [...topFilter.values, ...options];
        top_filter.title = "Explore the next 2 weeks";

        top_filter.value = new Date().setHours(0, 0, 0, 0) / 1000;

      }

      if (topFilter.populate == "daily") {

        let options = get_days(topFilter.today);
        top_filter.options = [...topFilter.values, ...options];
        top_filter.title = "Explore the next 2 weeks";

        top_filter.value = new Date().setHours(0, 0, 0, 0) / 1000;

      }

      if (topFilter.populate == "weekly") {

        let options = get_weeks(topFilter.today);
        top_filter.options = [...topFilter.values, ...options];
        top_filter.title = "Explore the next few weeks";

        if (topFilterDate.getDay() !== 1) {
          // If today is not Monday, find the previous Monday
          let previousMonday = getPreviousMonday(topFilterDate);
          topFilterDate.setTime(previousMonday.getTime());
        }

        topFilterDate.setDate(topFilterDate.getDate());
        topFilterDate.setHours(0, 0, 0, 0);

        top_filter.value = topFilterDate.getTime() / 1000;

      }

      if (topFilter.populate == "monthly") {

        let options = get_months(topFilter.today);
        top_filter.options = [...topFilter.values, ...options];
        top_filter.title = "Explore the next few months";

        const month = today.getMonth();

        topFilterDate.setDate(1);
        topFilterDate.setMonth(month);
        topFilterDate.setHours(0, 0, 0, 0);

        top_filter.value = topFilterDate.getTime() / 1000;

      }

      if (topFilter.populate == "yearly") {

        let options = get_years(topFilter.today);
        top_filter.options = [...topFilter.values, ...options];
        top_filter.title = "Explore the next few years";

        const currentYear = new Date().getFullYear();
        const firstDayOfYear = new Date(currentYear, 0, 1);
        firstDayOfYear.setHours(0, 0, 0, 0);
        top_filter.value = firstDayOfYear.getTime() / 1000;

      }

    } else if (topFilter.type == "search") {
      top_filter.value = '';
      top_filter.search_title = topFilter.search_title;
      top_filter.placeholder = topFilter.placeholder;
      top_filter.options = [...topFilter.values];
    } else {
      top_filter.options = [...topFilter.values];
      top_filter.value = "all";
    }

    if (language.top_nav_title.length){
      top_filter.title = language.top_nav_title;

    }



    return top_filter;
  } else {
    return {};
  }
}
